/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./Header.css";
import logo from "../assets/images/white-logo.png";
import menu from "../assets/images/menu.svg";
import { Fade } from "react-reveal";

export default function Header() {
  return (
    <Fade top>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img src={logo} alt="logo" />
            {/* <img src={omanv} alt="logo" /> */}

          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <img src={menu} alt="menu" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <a className="nav-link" href="#intro">
                  الرئيسية
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#about">
                  عن فاليو اكسبرت
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#services">
                  خدماتنا
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#activities">
                  الفاعليات
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#team">
                  فريق العمل
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#clients">
                  عملاؤنا
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact">
                  تواصل معنا
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="https://valuexperts.net/">
                 المملكة العربية السعودية
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </Fade>
  );
}
